import { ICoursesInPerson } from '../../interfaces/Website/Courses/CoursesInPerson/ICoursesInPerson'
import { IFormData } from '../../pages/Dashboard/Courses/Courses/CoursesModal'
import apiService from '../Api'
import { ICourse } from './interfaces'

export class CoursesService {
  async list(
    search: string,
    page: number,
    per_page: number
  ): Promise<{ total_filtered: number; data: ICoursesInPerson[] }> {
    return apiService
      .get('/courses', {
        params: {
          search,
          page,
          per_page
        }
      })
      .then((res) => res.data)
  }

  async getCourse(id: number): Promise<ICourse> {
    return apiService.get(`/courses/${id}`).then((res) => res.data)
  }

  async getKnowledgeAreas() {
    return apiService.get(`/courses/knowledge-areas`).then((res) => res.data)
  }

  async getDynamics() {
    return apiService.get(`/courses/dynamics`).then((res) => res.data)
  }

  async getObjectives() {
    return apiService.get(`/courses/objectives`).then((res) => res.data)
  }

  async getActiveCampaignLists() {
    return apiService.get(`/courses/active-campaign-lists`).then((res) => res.data.data)
  }

  async create(data: IFormData) {
    const formData = new FormData()

    formData.append('name', data.name)
    if (data.thumbnail) {
      formData.append('thumbnail', data.thumbnail)
    }
    formData.append('course_link', data.course_link)
    formData.append('full_price', data.full_price)
    formData.append('discount_percentage', data.discount_percentage)
    formData.append('duration_in_hours', String(data.duration_in_hours))
    formData.append('promotional_bar', data.promotional_bar)
    formData.append('duration_in_months', String(data.duration_in_months))
    formData.append('in_person', data.in_person ? '1' : '0')
    formData.append('live_online', data.live_online ? '1' : '0')

    if (data.promotional_bar === '1') {
      formData.append('cronometer_type', data.cronometer_type!)

      if (data.cronometer_type === 'end_date') {
        formData.append('cronometer_end_date', data.cronometer_end_date!)
      }

      if (data.cronometer_type === 'time') {
        formData.append('cronometer_time', data.cronometer_time!)
      }
    }

    data.knowledge_area_ids.forEach((area) => {
      formData.append('knowledge_area_ids[]', area)
    })
    data.objective_ids.forEach((objective) => {
      formData.append('objective_ids[]', objective)
    })
    data.dynamic_ids.forEach((dynamic) => {
      formData.append('dynamic_ids[]', dynamic)
    })
    data.active_campaign_in_person_lists.forEach((inPersonCampaign) => {
      formData.append('active_campaign_in_person_lists[]', inPersonCampaign)
    })
    data.active_campaign_live_online_lists.forEach((onlineCampaign) => {
      formData.append('active_campaign_live_online_lists[]', onlineCampaign)
    })

    return apiService.post('/courses', formData).then((res) => res.data)
  }

  async update(id: number, data: IFormData) {
    const formData = new FormData()

    formData.append('_method', 'PUT')
    formData.append('name', data.name)
    if (data.thumbnail && data.thumbnail instanceof File) {
      formData.append('thumbnail', data.thumbnail)
    }
    formData.append('course_link', data.course_link)
    formData.append('full_price', data.full_price)
    formData.append('discount_percentage', data.discount_percentage)
    formData.append('duration_in_hours', String(data.duration_in_hours))
    formData.append('promotional_bar', data.promotional_bar)
    formData.append('duration_in_months', String(data.duration_in_months))
    formData.append('in_person', data.in_person ? '1' : '0')
    formData.append('live_online', data.live_online ? '1' : '0')

    if (data.promotional_bar === '1') {
      formData.append('cronometer_type', data.cronometer_type!)

      if (data.cronometer_type === 'end_date') {
        formData.append('cronometer_end_date', data.cronometer_end_date!)
      }

      if (data.cronometer_type === 'time') {
        formData.append('cronometer_time', data.cronometer_time!)
      }
    }

    data.knowledge_area_ids.forEach((area) => {
      formData.append('knowledge_area_ids[]', area)
    })
    data.objective_ids.forEach((objective) => {
      formData.append('objective_ids[]', objective)
    })
    data.dynamic_ids.forEach((dynamic) => {
      formData.append('dynamic_ids[]', dynamic)
    })
    data.active_campaign_in_person_lists.forEach((inPersonCampaign) => {
      formData.append('active_campaign_in_person_lists[]', inPersonCampaign)
    })
    data.active_campaign_live_online_lists.forEach((onlineCampaign) => {
      formData.append('active_campaign_live_online_lists[]', onlineCampaign)
    })

    return apiService.post(`/courses/${id}`, formData).then((res) => res.data)
  }

  async updateEnable(id: number, enabled: boolean) {
    return apiService.put(`/courses/${id}`, {
      enabled: enabled ? '1' : '0'
    })
  }

  async delete(id: number) {
    return apiService.delete(`/courses/${id}`)
  }
}
